import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  listData: [],
  selectedEvent: {},
  selectedEventIndex: 1,
  totalEvents: 0,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
